import axios, { AxiosError } from "axios";
import { KullaniciTuru } from "../../types/enums";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { LoginError } from "../../types/ErrorModals/LoginError";
import { LoginRequestModal } from "../../types/RequestModals/LoginRequestModal";
import { KullaniciModal } from "../../types/modals"; 
import { API_URL } from "../../constants/API_URL";

export const login = async (credentials: LoginRequestModal): Promise<KullaniciModal> => {
  try {
    const response = await axios.post<ApiResponse<KullaniciModal>>(
      `${API_URL}/api/kullanici/login`,
      credentials
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data; 

      if (axiosError.response?.status === 429) {
        throw {
          message: responseData?.message || "Çok fazla deneme yapıldı",
          retryAfter: responseData?.additionalData?.RetryAfter,
          blockedUntil: responseData?.additionalData?.BlockedUntil
        } as LoginError;
      }

      if (axiosError.response?.status === 401) {
        throw {
          message: responseData?.message || "Kullanıcı adı veya şifre hatalı",
          remainingAttempts: responseData?.additionalData?.RemainingAttempts
        } as LoginError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu"
      } as LoginError;
    }

    throw { message: "Beklenmeyen bir hata oluştu" } as LoginError;
  }
}
